export default "__VITE_ASSET__BO2xQX7b__"